type ErrorArgs = {
  message: string;
  name: string;
  status?: number;
  errors?: unknown;
  /** Parsed JSON response body when the server returned JSON (for debugging / admin UIs). */
  responseBody?: unknown;
  detail?: unknown;
};

export default class ApiError extends Error {
  status?: number;
  errors?: unknown;
  responseBody?: unknown;
  detail?: unknown;

  constructor(args: ErrorArgs) {
    super(args.message);

    this.name = args.name;
    this.status = args.status;
    this.errors = args.errors;

    this.responseBody = args.responseBody;

    this.detail = args.detail;
  }
}
